import { getRandomInt } from '~/bootcamp/Activities/Fractions/Fractions.utils'

interface RangeModel {
  numerator: { min: number; max: number }
  denominator: { min: number; max: number }
  factor: { min: number; max: number }
  variation: number
}

interface DifficultyLevelRangeMapModel {
  [key: number]: RangeModel
}

export interface ProperFractionModel {
  numerator: number
  denominator: number
}

export interface FractionSimplifySelectQuestionModel {
  question: ProperFractionModel
  fractions: ProperFractionModel[]
  factor: number
  correctAnswerIndex: number
  maxVariation: number
}

const DIFFICULTY_LEVEL_RANGE_MAP: DifficultyLevelRangeMapModel = {
  1: { numerator: { min: 1, max: 4 }, denominator: { min: 2, max: 5 }, factor: { min: 2, max: 2 }, variation: 10 },
  2: { numerator: { min: 1, max: 4 }, denominator: { min: 4, max: 10 }, factor: { min: 5, max: 5 }, variation: 42 },
  3: { numerator: { min: 1, max: 4 }, denominator: { min: 4, max: 10 }, factor: { min: 3, max: 3 }, variation: 42 },
  4: { numerator: { min: 1, max: 4 }, denominator: { min: 4, max: 10 }, factor: { min: 6, max: 10 }, variation: 210 },
}

function generateOption(range: RangeModel, excludes?: Set<number>): ProperFractionModel {
  const denominator = getRandomInt(range.denominator.min, range.denominator.max)
  const numerator = getRandomInt(range.numerator.min, denominator - 1)
  const key = numerator / denominator
  if (excludes && excludes.has(key)) return generateOption(range, excludes)
  return { numerator, denominator }
}

export function getFractionSimplifySelectQuestionData(
  difficultyLevel: number,
  excludeFrac: string[],
): FractionSimplifySelectQuestionModel {
  const excludes = new Set(excludeFrac)
  const range = DIFFICULTY_LEVEL_RANGE_MAP[difficultyLevel]
  const options: ProperFractionModel[] = new Array<ProperFractionModel>(4)
  const optionHistory = new Set<number>()
  // eslint-disable-next-line
  for (let i = 0; i < 4; i++) {
    const { numerator, denominator } = generateOption(range, optionHistory)
    optionHistory.add(numerator / denominator)
    options[i] = { numerator, denominator }
  }

  const correctAnswerIndex = getRandomInt(0, 3)
  const factor = getRandomInt(range.factor.min, range.factor.min)
  const question: ProperFractionModel = {
    numerator: options[correctAnswerIndex].numerator * factor,
    denominator: options[correctAnswerIndex].denominator * factor,
  }

  if (excludes.has(`${question.numerator}-${question.denominator}`)) {
    return getFractionSimplifySelectQuestionData(difficultyLevel, excludeFrac)
  }
  return { question, fractions: options, factor, correctAnswerIndex, maxVariation: range.variation }
}
